function scrollToProductGrid() {
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    const top = grid.getBoundingClientRect().top + window.scrollY - 130;
    window.scrollTo({ top: Math.max(0, top) });
}

document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-pagination-link]')) return;
    scrollToProductGrid();
});
